import React, { useState, useEffect } from 'react';
import guitarImageA from '../assets/images/c2.png';
// Huta model images
import HutaC6Auctor from '../assets/images/Huta/Huta_C6_Auctor.png';
import HutaC6Peritus from '../assets/images/Huta/Huta_C6_Peritus.png';
import HutaM6Auctor from '../assets/images/Huta/Huta_M6_Auctor.png';
import HutaM6Peritus from '../assets/images/Huta/Huta_M6_Peritus.png';

// Yuta model images
import YutaC6Auctor from '../assets/images/Yuta/Yuta_C6_Auctor.png';
import YutaC6Peritus from '../assets/images/Yuta/Yuta_C6_Peritus.png';
import YutaM6Auctor from '../assets/images/Yuta/Yuta_M6_Auctor.png';
import YutaM6Peritus from '../assets/images/Yuta/Yuta_M6_Peritus.png';

// Hackistalker model images
import HackistalkerC6Auctor from '../assets/images/Hackistalker/Hackistalker_C6_Auctor.png';
import HackistalkerC6Peritus from '../assets/images/Hackistalker/Hackistalker_C6_Peritus.png';
import HackistalkerM6Auctor from '../assets/images/Hackistalker/Hackistalker_M6_Auctor.png';
import HackistalkerM6Peritus from '../assets/images/Hackistalker/Hackistalker_M6_Peritus.png';


const ModelsSection = () => {
  const [selectedGuitar, setSelectedGuitar] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1000);
  
  // State for style and configuration toggles per guitar
  const [guitarStyles, setGuitarStyles] = useState({
    'Huta': 'Classic',
    'Yuta': 'Classic',
    'Hackistalker': 'Modern'
  });
  
  const [guitarConfigs, setGuitarConfigs] = useState({
    'Huta': 'Auctor',
    'Yuta': 'Peritus',
    'Hackistalker': 'Auctor'
  });

  const guitarModels = {
    'Huta': {
      name: 'Huta',
      description: 'The Huta is Vitæ Guitars\' refined take on the offset - a modern instrument rooted in classic inspiration but reimagined for today\'s player. Its silhouette flows with sleek, organic lines that naturally position the body and hands for comfort, whether you\'re locking into chords or climbing effortlessly into the higher frets. Unlike many offsets that lean bulky, the Huta is crafted with a smaller, lighter body, giving it a uniquely agile feel without sacrificing presence or resonance.\n\nIn your hands, the Huta feels both effortless and alive. Its compact build makes long sessions comfortable, while the carefully contoured shape moves with you rather than against you. Sonically, it balances warmth and clarity: a punchy low end that stays tight, mids that cut through without harshness, and a shimmering top end that gives both cleans and overdriven tones a distinct voice. It\'s an instrument that responds to every touch - articulate, dynamic, and ready for anything from subtle textures to soaring leads.',
      variants: {
        Classic: {
          Auctor: {
            image: HutaC6Auctor,
            fullDesc: 'The Classic T-Style Auctor represents our commitment to honoring tradition while embracing innovation. Built with a premium Canadian maple neck and East Indian rosewood fingerboard, this guitar delivers the classic twang and bite you expect.',
            price: 2899,
            specs: {
              body: 'Premium Alder',
              top: 'Flamed Maple Cap',
              neck: 'Canadian Hard Rock Maple',
              fingerboard: 'East Indian Rosewood',
              pickups: 'Custom Vitæ Single-Coil Set',
              bridge: 'Classic-Style 6-Saddle Bridge',
              tuners: 'Locking Tuners',
              finish: 'Nitrocellulose Lacquer'
            }
          },
          Peritus: {
            image: HutaC6Peritus,
            fullDesc: 'The Classic T-Style Peritus features enhanced traditional elements with modern reliability. This variant offers a warmer, more classic-focused tone profile.',
            price: 3199,
            specs: {
              body: 'Swamp Ash',
              top: 'Aged Maple Cap',
              neck: 'Canadian Hard Rock Maple',
              fingerboard: 'East Indian Rosewood',
              pickups: 'Classic-Style Single-Coil Set',
              bridge: 'Classic-Style 3-Saddle Bridge', 
              tuners: 'Classic-Style Tuners',
              finish: 'Aged Nitrocellulose Lacquer'
            }
          }
        },
        Modern: {
          Auctor: {
            image: HutaM6Auctor,
            fullDesc: 'The Modern T-Style Auctor pushes the classic design into contemporary territory with cutting-edge appointments and enhanced playability.',
            price: 3499,
            specs: {
              body: 'Premium Mahogany',
              top: 'Quilted Maple Cap', 
              neck: 'Roasted Canadian Maple',
              fingerboard: 'Ebony with Pearl Inlays',
              pickups: 'Modern High-Output Single-Coil Set',
              bridge: 'Modern 6-Saddle Bridge with Block Saddles',
              tuners: 'Locking Tuners with 18:1 Ratio',
              finish: 'Satin Polyurethane'
            }
          },
          Peritus: {
            image: HutaM6Peritus,
            fullDesc: 'The Modern T-Style Peritus represents the pinnacle of contemporary T-Style evolution, featuring premium electronics and enhanced ergonomics.',
            price: 3899,
            specs: {
              body: 'Premium Ash with Walnut Accent',
              top: 'Flame Maple Cap',
              neck: 'Roasted Canadian Maple with Carbon Fiber Reinforcement',
              fingerboard: 'Ebony with Abalone Inlays',
              pickups: 'Custom Modern Humbucker/Single-Coil Set',
              bridge: 'Modern Tremolo System',
              tuners: 'Locking Tuners with 20:1 Ratio',
              finish: 'High-Gloss Polyurethane'
            }
          }
        }
      },
      features: [
        'Hand-wound custom pickups for authentic classic tone',
        'Compound radius fingerboard for comfort and playability',
        'Bone nut and brass saddles for enhanced sustain',
        'Custom electronics with premium capacitors',
        'Hand-rubbed nitrocellulose finish'
      ]
    },
    'Yuta': {
      name: 'Yuta',
      description: 'The Yuta is Vitæ Guitars\' modern reimagining of the classic single cut. While the original is known for its simple slab body charm, the Yuta refines the formula with a smaller, more ergonomic design and carefully sculpted contours for the arm and belly. The result is a guitar that stays true to the timeless silhouette while offering a more comfortable and fluid playing experience, perfect for long hours on stage or in the studio.\n\nIn your hands, the Yuta feels instantly familiar yet refreshingly new. Its compact shape hugs the body while the contours make every position feel natural. Tonally, it channels the spirit of the single cut with a crisp, articulate bite and rich resonance, but with added warmth and balance that broaden its versatility. Expect sharp, defined attacks for rock and blues riffs, glassy cleans that shimmer with character, and a responsive dynamic range that adapts beautifully to your touch.',
      variants: {
        Classic: {
          Auctor: {
            image: YutaC6Auctor,
            fullDesc: 'The Classic Modern Offset Auctor combines traditional offset ergonomics with time-tested electronics for a classic-inspired playing experience.',
            price: 2699,
            specs: {
              body: 'Premium Alder with Maple Cap',
              neck: 'Canadian Maple',
              fingerboard: 'Rosewood with Dot Inlays',
              pickups: 'Classic-Style Single-Coil Set',
              bridge: 'Classic Tremolo System',
              tuners: 'Classic-Style Tuners',
              electronics: '3-Way Switch',
              finish: 'Nitrocellulose Lacquer'
            }
          },
          Peritus: {
            image: YutaC6Peritus,
            fullDesc: 'The Classic Modern Offset Peritus features enhanced classic appointments with improved reliability and modern playability.',
            price: 3099,
            specs: {
              body: 'Premium Basswood with Maple Cap',
              neck: 'Canadian Maple with Classic Tint',
              fingerboard: 'Rosewood with Block Inlays',
              pickups: 'Classic Hot Single-Coil Set',
              bridge: 'Classic Tremolo with Steel Block',
              tuners: 'Classic-Style Locking Tuners',
              electronics: '5-Way Switch',
              finish: 'Aged Nitrocellulose Lacquer'
            }
          }
        },
        Modern: {
          Auctor: {
            image: YutaM6Auctor,
            fullDesc: 'The Modern Offset Auctor pushes boundaries with its ergonomic offset body design and versatile electronics, crafted for the contemporary player.',
            price: 3299,
            specs: {
              body: 'Premium Mahogany with Maple Cap',
              neck: 'Roasted Canadian Maple',
              fingerboard: 'Ebony with Mother of Pearl Inlays',
              pickups: 'Custom Vitæ Humbucker/Single-Coil Set',
              bridge: 'Modern Tremolo System',
              tuners: 'Locking Tuners with 18:1 Ratio',
              electronics: '5-Way Switch with Coil Tap',
              finish: 'Polyurethane with Hand-Buffed Gloss'
            }
          },
          Peritus: {
            image: YutaM6Peritus,
            fullDesc: 'The Modern Offset Peritus represents the pinnacle of offset design evolution, featuring cutting-edge electronics and enhanced ergonomics.',
            price: 3799,
            specs: {
              body: 'Premium Ash with Walnut Accent',
              neck: 'Roasted Maple with Carbon Fiber Reinforcement', 
              fingerboard: 'Ebony with LED Position Markers',
              pickups: 'Active Humbucker/Single-Coil System',
              bridge: 'Modern Locking Tremolo System',
              tuners: 'Locking Tuners with 20:1 Ratio',
              electronics: '7-Way Switch with Active Preamp',
              finish: 'High-Gloss Polyurethane with UV Protection'
            }
          }
        }
      },
      features: [
        'Ergonomic offset body for superior comfort',
        'Coil-tap capability for tonal versatility',
        'Modern tremolo system with enhanced stability',
        'Roasted maple neck for superior tone and stability',
        'Custom switching for 10+ pickup combinations'
      ]
    },
    'Hackistalker': {
      name: 'Hackistalker',
      description: 'The Hackistalker is Vitæ Guitars\' bold take on the modern double cut design - a sleek, offset design with a compact body built for comfort and speed. Its contoured curves and smaller footprint make it feel agile and perfectly balanced, equally suited for technical precision or expressive rhythm work. Lightweight yet commanding, it\'s the kind of guitar that feels like an extension of the player rather than a tool you have to wrestle with.\n\nSonically, the Hackistalker is designed for versatility and clarity. Expect a tight, articulate response with resonant lows, defined mids, and a crisp top end that shines whether you\'re layering clean textures or pushing into heavy distortion. With a modern aesthetic that favors smooth lines and refined finishes, it\'s a guitar that looks as sharp as it sounds - a future classic built for players who demand both style and substance.',
      variants: {
        Classic: {
          Auctor: {
            image: HackistalkerC6Auctor,
            fullDesc: 'The Classic Hackistalker Auctor delivers traditional double cut performance with modern refinements. Built for players who demand versatility and precision.',
            price: 3600,
            specs: {
              body: 'Premium Alder with Contoured Edges',
              neck: 'Canadian Hard Rock Maple',
              fingerboard: 'East Indian Rosewood',
              pickups: 'Custom Vitæ Humbucker Set',
              bridge: 'Fixed Bridge with String-Through Body',
              tuners: 'Locking Tuners',
              electronics: '3-Way Switch with Coil Tap',
              finish: 'Nitrocellulose Lacquer'
            }
          },
          Peritus: {
            image: HackistalkerC6Peritus,
            fullDesc: 'The Classic Hackistalker Peritus features premium appointments and enhanced electronics for professional performance and recording.',
            price: 5200,
            specs: {
              body: 'Premium Ash with Maple Cap',
              neck: 'Roasted Canadian Maple',
              fingerboard: 'Ebony with Mother of Pearl Inlays',
              pickups: 'Custom Vitæ Active Humbucker System',
              bridge: 'High-Performance Fixed Bridge',
              tuners: 'Locking Tuners with 18:1 Ratio',
              electronics: '5-Way Switch with Active Preamp',
              finish: 'High-Gloss Polyurethane'
            }
          }
        },
        Modern: {
          Auctor: {
            image: HackistalkerM6Auctor,
            fullDesc: 'The Modern Hackistalker Auctor combines contemporary double cut design with cutting-edge electronics for maximum versatility.',
            price: 3600,
            specs: {
              body: 'Premium Mahogany with Maple Cap',
              neck: 'Roasted Canadian Maple',
              fingerboard: 'Ebony with White Dot Inlays',
              pickups: 'Custom Vitæ Modern Humbucker Set',
              bridge: 'Modern Tremolo System',
              tuners: 'Locking Tuners with 18:1 Ratio',
              electronics: '5-Way Switch with Coil Tap',
              finish: 'Satin Polyurethane'
            }
          },
          Peritus: {
            image: HackistalkerM6Peritus,
            fullDesc: 'The Modern Hackistalker Peritus represents the pinnacle of double cut evolution with advanced electronics and premium appointments.',
            price: 5200,
            specs: {
              body: 'Premium Ash with Walnut Accent',
              neck: 'Roasted Maple with Carbon Fiber Reinforcement',
              fingerboard: 'Ebony with LED Position Markers',
              pickups: 'Active Humbucker System with Coil Tap',
              bridge: 'Modern Locking Tremolo System',
              tuners: 'Locking Tuners with 20:1 Ratio',
              electronics: '7-Way Switch with Active Preamp',
              finish: 'High-Gloss Polyurethane with UV Protection'
            }
          }
        }
      },
      features: [
        'Contoured body design for superior comfort and access',
        'High-output humbuckers with coil-tap versatility',
        'Modern tremolo system with enhanced stability',
        'Fast-playing neck profile optimized for technical performance',
        'Advanced switching system for maximum tonal options'
      ]
    }
  };

  // Helper function to get current variant data
  const getCurrentVariant = (guitarKey) => {
    const guitar = guitarModels[guitarKey];
    const style = guitarStyles[guitarKey];
    const config = guitarConfigs[guitarKey];
    
    if (!guitar || !style || !config) {
      console.warn(`Missing data for guitar ${guitarKey}:`, { guitar: !!guitar, style, config });
      return null;
    }
    
    const variant = guitar.variants?.[style]?.[config];
    if (!variant) {
      console.warn(`Variant not found for ${guitarKey} - ${style} - ${config}`);
      return null;
    }
    

    return variant;
  };

  // Toggle handlers
  const handleStyleToggle = (guitarKey, style) => {
    setGuitarStyles(prev => ({ ...prev, [guitarKey]: style }));
  };

  const handleConfigToggle = (guitarKey, config) => {
    setGuitarConfigs(prev => ({ ...prev, [guitarKey]: config }));
  };

  const handleCardClick = (guitarKey) => {
    setSelectedGuitar(prev => prev === guitarKey ? null : guitarKey);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1000);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && selectedGuitar) {
        setSelectedGuitar(null);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [selectedGuitar]);

  return (
    <section id="models" className={`py-32 ${isDesktop ? 'pb-32' : 'pb-24'} bg-theme-bg-secondary relative`}>
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <span className="text-theme-primary-400 tracking-[0.2em] uppercase text-sm font-bold mb-2 block">Our Collection</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">Models</h2>
        </div>

        {/* Guitar Cards Layout */}
        <div className={`flex ${isDesktop ? 'flex-row items-start justify-center' : 'flex-col items-center'} gap-8 max-w-7xl mx-auto`}>
          {Object.entries(guitarModels).map(([key, guitar], index) => (
            <div
              key={key}
              className="group transition-all duration-700 cubic-bezier(0.4, 0, 0.2, 1) flex justify-center"
              style={{
                maxWidth: selectedGuitar === key
                  ? (isDesktop ? 'min(900px, calc(100vw - 100px))' : '100%')
                  : '280px',
                width: selectedGuitar === key
                  ? (isDesktop ? 'min(900px, calc(100vw - 100px))' : '100%')
                  : '280px',
                minWidth: isDesktop ? '280px' : '100%',
                flexShrink: 0,
                transition: 'width 0.7s cubic-bezier(0.4, 0, 0.2, 1), max-width 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
            >
              <div
                className={`w-full rounded-xl overflow-hidden border border-white/5 shadow-2xl transition-all duration-700 cubic-bezier(0.4, 0, 0.2, 1) cursor-pointer select-none group relative flex ${isDesktop ? 'flex-row' : 'flex-col'} ${
                  selectedGuitar === key
                    ? 'shadow-[0_0_60px_rgba(255,122,51,0.45)] border-theme-primary-400/50 bg-theme-bg-card'
                    : 'hover:shadow-[0_0_40px_rgba(255,122,51,0.35)] hover:border-theme-primary-400/30 hover:-translate-y-2 bg-white/5'
                }`}
                onClick={() => handleCardClick(key)}
                style={{ 
                  touchAction: 'manipulation',
                  height: selectedGuitar === key ? 'auto' : '600px',
                  minHeight: '600px'
                }}
              >
                  {/* Main Content - Responsive Layout */}
                  <div className={`flex ${isDesktop ? 'flex-row items-stretch' : 'flex-col'} transition-all duration-700 cubic-bezier(0.4, 0, 0.2, 1) relative ${
                    selectedGuitar === key && isDesktop ? 'w-1/3' : 'w-full'
                  }`}
                  style={{ height: '600px' }}
                  >
                    
                    {/* Guitar Image Container */}
                    <div className="absolute inset-0">
                      <img 
                        src={getCurrentVariant(key)?.image}
                        alt={`Vitæ Guitars ${guitar.name}`}
                        loading="eager"
                        className="w-full h-full object-contain object-center transition-transform duration-700 ease-out group-hover:scale-105 p-8"
                        onError={(e) => {
                          console.error(`Failed to load image for ${guitar.name}`, e);
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                    
                    {/* Overlay - visible only on hover (and never when expanded) */}
                    <div className={`absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-black via-black/50 to-transparent transition-opacity duration-500 flex flex-col justify-end p-8 opacity-0 pointer-events-none ${
                      selectedGuitar === key ? '' : 'group-hover:opacity-100'
                    }`}>
                      <h3 className="text-3xl font-bold text-white mb-2 tracking-wide">{guitar.name}</h3>
                      <p className="text-theme-primary-400 font-medium tracking-wider uppercase text-sm">Click to Explore</p>
                    </div>
                  </div>
                  
                  {/* Expandable Details */}
                  <div
                    className={`overflow-hidden bg-theme-bg-card transition-all duration-700 cubic-bezier(0.4, 0, 0.2, 1) ${
                      selectedGuitar === key
                        ? 'opacity-100 w-full md:w-2/3' 
                        : 'w-0 opacity-0' 
                    }`}
                    style={{
                      width: selectedGuitar === key ? (isDesktop ? '66.666%' : '100%') : '0px',
                      height: selectedGuitar === key ? 'auto' : '0px',
                      transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                  >
                    <div className={`h-full flex flex-col ${
                      selectedGuitar === key ? 'overflow-y-auto' : 'overflow-hidden'
                    }`}>
                      {/* Content Container with Padding */}
                      <div className="p-10 pb-24 flex-grow flex flex-col">
                        <div className="flex justify-between items-start mb-8">
                          <div>
                            <h2 className="text-4xl font-bold text-white mb-2">{guitar.name}</h2>
                            <div className="h-1 w-20 bg-theme-primary-500 rounded-full"></div>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedGuitar(null);
                            }}
                            className="text-gray-400 hover:text-white transition-colors p-2 rounded-full hover:bg-white/5"
                            aria-label="Close details"
                          >
                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        </div>

                        {/* Full Width Description */}
                        <div className="mb-12 order-2 lg:order-1">
                          <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                            <i className="fas fa-info-circle text-theme-primary-400"></i> About
                          </h3>
                          <div className="text-gray-400 leading-relaxed whitespace-pre-line text-sm max-w-4xl">
                            {guitar.description}
                          </div>
                        </div>

                        {/* Grid for Toggles and Specs */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-10 order-1 lg:order-2">
                          {/* Left Column: Toggles */}
                          <div className="space-y-8">
                            {/* Style Toggle */}
                            <div>
                              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Style</label>
                              <div
                                className="flex bg-white/5 p-1 rounded-full border border-white/10 cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const currentStyle = guitarStyles[key];
                                  const newStyle = currentStyle === 'Classic' ? 'Modern' : 'Classic';
                                  handleStyleToggle(key, newStyle);
                                }}
                              >
                                {['Classic', 'Modern'].map((style) => (
                                  <button
                                    key={style}
                                    className={`flex-1 py-2 px-4 rounded-full transition-all duration-300 font-medium text-sm ${
                                      guitarStyles[key] === style
                                        ? 'bg-theme-primary-400 text-white shadow-lg'
                                        : 'text-gray-400 hover:text-white'
                                    }`}
                                  >
                                    {style}
                                  </button>
                                ))}
                              </div>
                            </div>

                            {/* Configuration Toggle */}
                            <div>
                              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Series</label>
                              <div
                                className="flex bg-white/5 p-1 rounded-full border border-white/10 cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const currentConfig = guitarConfigs[key];
                                  const newConfig = currentConfig === 'Auctor' ? 'Peritus' : 'Auctor';
                                  handleConfigToggle(key, newConfig);
                                }}
                              >
                                {['Auctor', 'Peritus'].map((config) => (
                                  <button
                                    key={config}
                                    className={`flex-1 py-2 px-4 rounded-full transition-all duration-300 font-medium text-sm ${
                                      guitarConfigs[key] === config
                                        ? 'bg-theme-primary-400 text-white shadow-lg'
                                        : 'text-gray-400 hover:text-white'
                                    }`}
                                  >
                                    {config}
                                  </button>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Right Column: Minimal Specs */}
                          <div className="pt-2">
                            <h3 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
                              <i className="fas fa-list-ul text-theme-primary-400"></i> {guitarConfigs[key]} Specs
                            </h3>
                            {guitarConfigs[key] === 'Peritus' ? (
                              <ul className="space-y-4 text-sm text-gray-300">
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">Top wood over chambered body</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">5-7 piece neck construction</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">Premium fretboard binding</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">High-end electronics package</span>
                                </li>
                              </ul>
                            ) : (
                              <ul className="space-y-4 text-sm text-gray-300">
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">Solid body construction</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">3 piece neck construction</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">Standard electronics package</span>
                                </li>
                                <li className="flex items-start gap-3 group">
                                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-theme-primary-500 group-hover:scale-125 transition-transform"></span>
                                  <span className="group-hover:text-white transition-colors">Unbound fretboard</span>
                                </li>
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>

                      </div>
                    </div>


                  {/* Footer with Distinct Background - Full Width Absolute */}
                  <div
                    className={`absolute bottom-0 left-0 w-full bg-black/80 backdrop-blur-md border-t border-white/10 px-6 py-4 flex items-center justify-between z-20 ${
                      selectedGuitar === key ? 'opacity-100 translate-y-0 transition-all duration-500' : 'opacity-0 translate-y-4 pointer-events-none'
                    }`}
                  >
                    <div>
                      <span className="block text-gray-500 text-[10px] uppercase tracking-wider mb-0.5">Starting Price</span>
                      <div className="text-2xl font-bold text-white">
                        ${guitarConfigs[key] === 'Auctor' ? '3,600' : '5,200'}
                      </div>
                    </div>
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        const style = guitarStyles[key].toLowerCase();
                        const config = guitarConfigs[key];
                        const configKey = config;
                        const params = new URLSearchParams({
                          model: key,
                          config: configKey,
                          style: style
                        });
                        window.history.pushState({}, '', `/builder?${params.toString()}`);
                        window.dispatchEvent(new PopStateEvent('popstate'));
                      }}
                      className="bg-theme-primary-400 text-white px-6 py-2 rounded-lg font-bold tracking-wider hover:bg-theme-primary-500 hover:shadow-lg hover:shadow-theme-primary-400/20 transition-all transform hover:-translate-y-1 text-sm"
                    >
                      Build Yours
                    </button>
                  </div>
              </div>
            </div>
          ))}

          </div>
        </div>
      </section>
    );
  };
  
  export default ModelsSection;
